/**
 * Management accounting reports
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';





/**
* The EmployeesDebts model module.
* @module model/EmployeesDebts
* @version 1.0.0
*/
export default class EmployeesDebts {
    /**
    * Constructs a new <code>EmployeesDebts</code>.
    * Задолженность сотрудников
    * @alias module:model/EmployeesDebts
    * @class
    * @param _date {Date} 
    * @param high {Number} 
    * @param middle {Number} 
    * @param low {Number} 
    * @param total {Number} 
    */

    constructor(_date, high, middle, low, total) {
        

        
        

        this['date'] = _date;this['high'] = high;this['middle'] = middle;this['low'] = low;this['total'] = total;

        
    }

    /**
    * Constructs a <code>EmployeesDebts</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/EmployeesDebts} obj Optional instance to populate.
    * @return {module:model/EmployeesDebts} The populated <code>EmployeesDebts</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EmployeesDebts();

            
            
            

            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'Date');
            }
            if (data.hasOwnProperty('high')) {
                obj['high'] = ApiClient.convertToType(data['high'], 'Number');
            }
            if (data.hasOwnProperty('middle')) {
                obj['middle'] = ApiClient.convertToType(data['middle'], 'Number');
            }
            if (data.hasOwnProperty('low')) {
                obj['low'] = ApiClient.convertToType(data['low'], 'Number');
            }
            if (data.hasOwnProperty('total')) {
                obj['total'] = ApiClient.convertToType(data['total'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {Date} date
    */
    date = undefined;
    /**
    * @member {Number} high
    */
    high = undefined;
    /**
    * @member {Number} middle
    */
    middle = undefined;
    /**
    * @member {Number} low
    */
    low = undefined;
    /**
    * @member {Number} total
    */
    total = undefined;








}


